

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';
import { DataUtilService } from './data-util.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class SubTopicService {
  aHeader = undefined



  constructor(
    private http: HttpClient,
    private headerService:HeaderService,
    private dataUtilService:DataUtilService,
    ) { }

    getSubTopicById(subTopicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/apishow/${subTopicId}`,{headers:hh})
    }
    getSubTopicsByTopicId(subTopicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/apisubtopicsbytopic/${subTopicId}`,{headers:hh})
    }

    getSubTopicIdAndNameByTopicId(topicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/subTopicIdAndNameByTopic/${topicId}`,{headers:hh})
    }
    deleteSubTopicById(subTopicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/deleteItem/${subTopicId}`,{headers:hh})
    }
    addSubTopic(formData:string):Observable<ResultData>{
      const hh = this.headerService.bearerFormHeaders()
      return this.http.post<ResultData>(`${environment.apiUrl}/topic/addSubtopic`, formData,{headers:hh})
    }

    editSubTopic(formData:string):Observable<ResultData>{
      const hh = this.headerService.bearerFormHeaders()
      return this.http.post<ResultData>(`${environment.apiUrl}/subTopic/editSubtopic`, formData,{headers:hh})
    }

    searchSubTopic(val:string):Observable<ResultData>{

        const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/searchByName/${val}`,{headers:hh})
      }

      searchSubTopicAll(val:string):Observable<ResultData>{
        const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/searchByName/${val}`,{headers:hh})
      }

      getSubTopicList():Observable<ResultData>{
        const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/all`,{headers:hh})
      }
      getSubTopicListByTopicId(topicId:number):Observable<ResultData>{
        const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/allByTopic/${topicId}`,{headers:hh})
      }
}
